import { base } from '@/layouts'
import { requiresAdmin } from '@/lib/auth.js'

export default [ {
  path: 'you',
  component: base,
  children: [
    {
      name: 'you',
      path: '',
      component: () => import('@/views/You'),
    },
    {
      path: 'account',
      component: base,
      beforeEnter: requiresAdmin,
      children: [
        {
          name: 'account',
          path: '',
          component: () => import('@/views/You/Account'),
          beforeEnter: requiresAdmin,
        },
        {
          path: 'W9',
          component: base,
          beforeEnter: requiresAdmin,
          children: [
            {
              name: 'account/w9/certification',
              path: 'certification',
              component: () => import('@/views/You/Account/W9/Certification'),
              beforeEnter: requiresAdmin,
            },
            {
              name: 'account/w9/form',
              path: 'form',
              component: () => import('@/views/You/Account/W9/Form'),
              beforeEnter: requiresAdmin,
            },
            {
              name: 'account/w9/form2',
              path: 'form2',
              component: () => import('@/views/You/Account/W9/Form2'),
              beforeEnter: requiresAdmin,
            },
            {
              name: 'account/w9/thanks',
              path: 'thanks',
              component: () => import('@/views/You/Account/W9/Thanks'),
              beforeEnter: requiresAdmin,
            },
          ],
        },
      ],
    },
    {
      path: 'legal',
      component: base,
      children: [
        {
          name: 'you/legal',
          path: '',
          component: () => import('@/views/You/Legal'),
        },
        {
          name: 'legal/w-9-cert',
          path: 'w-9-cert',
          component: () => import('@/views/You/Legal/W-9-Cert'),
        },
        {
          name: 'legal/privacy',
          path: 'privacy',
          component: () => import('@/views/You/Legal/Privacy'),
        },   
        {
          name: 'legal/referrer',
          path: 'referrer',
          component: () => import('@/views/You/Legal/EULA'),
        },
      ]
    },
    {
      name: 'you/password',
      path: 'password',
      component: () => import('@/views/You/Password'),
    },
    {
      path: 'profile',
      component: base,
      children: [
        {
          name: 'profile',
          path: '',
          component: () => import('@/views/You/Profile'),
        },
        {
          name: 'profile/wizard/congrats',
          path: 'wizard/congrats',
          component: () => import('@/views/You/Profile/Wizard/Congratulations'),
        },
        {
          name: 'profile/wizard/step1',
          path: 'wizard/step1',
          component: () => import('@/views/You/Profile/Wizard/Step1'),
        },
        {
          name: 'profile/wizard/verify',
          path: 'wizard/verify/:device_id(\\d+)',
          component: () => import('@/views/You/Profile/Wizard/Verify'),
          props: true,
        },
        {
          name: 'profile/devices',
          path: 'devices',
          component: () => import('@/views/You/Profile/Devices'),
        },
      ],
    },
    {
      path: 'users',
      component: base,
      beforeEnter: requiresAdmin,
      children: [
        {
          name: 'you/users',
          path: '',
          component: () => import('@/views/You/Users'),
        },
        {
          name: 'you/users/show',
          path: ':user_id(\\d+)',
          component: () => import('@/views/You/Users/Show'),
          props: true,
        },    
      ]
    },
    {
      path: 'w9',
      component: base,
      children: [
        {
          name: 'w9/certification',
          path: 'certification',
          component: () => import('@/views/You/W9/Certification'),
        },
        {
          name: 'w9/form',
          path: 'form',
          component: () => import('@/views/You/W9/Form'),
        },
        {
          name: 'w9/thanks',
          path: 'thanks',
          component: () => import('@/views/You/W9/Thanks'),
        },
      ],
    },
  ],
} ]